import { render, staticRenderFns } from "./purchases-review.vue?vue&type=template&id=8fe8d3d8&scoped=true"
import script from "./purchases-review.vue?vue&type=script&lang=js"
export * from "./purchases-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe8d3d8",
  null
  
)

export default component.exports